import { createDiv, delay } from "../util";

export enum Symbol {
    Blank,
    Star,
    X
}

export class Reel {
    div: HTMLElement;
    symbolDiv: HTMLElement;
    symbolOptions: Symbol[] = [];
    currentSymbol = Symbol.Blank;
    isSpinning = false;

    private spinSpeed = 200;

    createElement(parent: HTMLElement) {
        this.div = createDiv(parent, "reel");
        this.symbolDiv = createDiv(this.div, "symbol");
        this.setSymbol(this.currentSymbol);
        return this.div;
    }

    addOption(symbol: Symbol) {
        this.symbolOptions.push(symbol);
    }

    setSymbol(symbol: Symbol) {
        this.currentSymbol = symbol;
        this.symbolDiv.className = "symbol";
        this.symbolDiv.classList.add("symbol-"+symbol);
    }

    async spin(spinTime: number) {
        this.isSpinning = true;
        this.div.classList.add("spinning");

        // random delay before start
        await delay(this.spinSpeed * Math.random());

        this.symbolDiv.style.transition = `transform ${this.spinSpeed}ms`;
        this.showSpin(0);
        await delay(spinTime);
        this.isSpinning = false; // stops spinning in < spinSpeed...
        this.div.classList.remove("spinning");

        // back to normal
        this.div.innerHTML = "";
        const symbol = this.symbolOptions[Math.floor(Math.random()*this.symbolOptions.length)];
        this.symbolDiv = createDiv(this.div, "symbol");
        this.setSymbol(symbol);
    }

    async showSpin(spinIndex: number) {
        if (this.isSpinning) {
            var nextSpinIndex = (spinIndex + 1) % this.symbolOptions.length;
            var thisSymbol = this.symbolOptions[spinIndex];
            var nextSymbol = this.symbolOptions[nextSpinIndex];
            
            this.div.innerHTML = "";
            var thisSymbolDiv = createDiv(this.div, "symbol symbol-"+thisSymbol);
            thisSymbolDiv.style.transition = `transform ${this.spinSpeed}ms`;
            thisSymbolDiv.style.transform = "translate(0, 0)";

            var nextSymbolDiv = createDiv(this.div, "symbol symbol-"+nextSymbol);
            nextSymbolDiv.style.transition = `transform ${this.spinSpeed}ms`;
            nextSymbolDiv.style.transform = "translate(0, -35px)";
            
            await delay(0); // it's the transition that matters, not this
            
            thisSymbolDiv.style.transform = "translate(0, 35px)";
            nextSymbolDiv.style.transform = "translate(0, 0)";

            // now both will move for spinSpeed ms

            setTimeout(() => {
                this.showSpin(nextSpinIndex);
            }, this.spinSpeed);
        }
    };

    // Place symbol at the top
    // Move symbol to bottom
    // Use transition to animate it
    // Repeat

    reset() {
        this.symbolOptions = [];
        this.setSymbol(Symbol.Blank);
    }
}